import { Button } from "../../../../../../../components/button.jsx";
import React from "react";
import { TRANSACTION_IMPORT_MODAL } from "../../transactionImportModal.jsx";
import { useModal } from "../../../../../../../hooks/useModal.js";
import { useResource } from "../../../../../../../hooks/useResource.js";

export function StepConfirm({ file, setFile, pagination }) {
  let { closeModal } = useModal();

  let transactionsService = useResource("transactions");
  const onImport = (d) => {
    transactionsService.collectionAction("import", d).then((transactions) => {
      pagination.prepend(transactions);
      closeModal(TRANSACTION_IMPORT_MODAL);
    });
  };

  let mappedData = file.data[0].data
    .map((row, rowIndex) => {
      if (!file.removedLines.includes(rowIndex)) {
        let res = {};

        row.forEach((col, colIndex) => {
          res[file.mapping[colIndex]] = col;
        });

        res["dateFormat"] = file.mapping["dateFormat"];

        return res;
      }
    })
    .filter((x) => !!x);
  return (
    <div className={"flex flex-col gap-3"}>
      <p>
        You are going to import {file.data[0].data.length} entries. Click on the
        button below to confirm.
      </p>
      <div className={"overflow-auto"}>
        <table>
          <thead>
            <tr>
              <th>date</th>
              <th>contact</th>
              <th>amount</th>
              <th>currency</th>
              <th>description</th>
            </tr>
          </thead>
          <tbody>
            {mappedData
              .slice(0, 4)
              .map(({ date, contact, amount, currency, description }) => (
                <tr
                  className={
                    "whitespace-nowrap overflow-hidden overflow-ellipsis"
                  }
                >
                  <td className={"px-2"}>{date}</td>
                  <td className={"px-2"}>{contact}</td>
                  <td className={"px-2"}>{amount}</td>
                  <td className={"px-2"}>{currency}</td>
                  <td className={"px-2"}>{description}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <Button onClick={() => onImport(mappedData)}>Import</Button>
    </div>
  );
}
